import React from 'react';
import { motion } from 'framer-motion';
import { FaStar } from 'react-icons/fa';

const Feedback = () => {
    const testimonials = [
        { name: 'Eng. Thilina Wijay', role: 'Civil Engineering', text: 'Mathematical logic was my biggest hurdle until I joined Manoj sirs classes. He transformed complex integration into intuitive spatial models.' },
        { name: 'Ishara Perera', role: 'Software Architect', text: 'The algorithmic thinking I developed in Combined Maths still powers my system designs today. More than a tutor, he is a logic architect.' },
        { name: 'Kavindi de Silva', role: 'Island Top - Combined Maths', text: 'I never felt like I was memorizing. Manoj sirs first-principles approach made the most difficult mechanics feel like childs play.' }
    ];

    return (
        <section className="py-32 px-6 bg-[#0a0a0a]">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-24">
                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="flex items-center justify-center gap-4 mb-4"
                    >
                        <div className="h-[2px] w-8 bg-blue-500"></div>
                        <span className="text-blue-500 font-bold uppercase tracking-widest text-xs">Success Stories</span>
                        <div className="h-[2px] w-8 bg-blue-500"></div>
                    </motion.div>
                    <motion.h2
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.1 }}
                        className="text-3xl md:text-5xl font-black tracking-tight text-white uppercase"
                    >
                        STUDENT <span className="text-blue-500">FEEDBACK</span>
                    </motion.h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {testimonials.map((t, idx) => (
                        <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: idx * 0.1 }}
                            viewport={{ once: true }}
                            className="bg-white/[0.03] backdrop-blur-xl p-12 rounded-[2.5rem] flex flex-col justify-between h-full border border-white/5 hover:border-blue-500/30 transition-all duration-500 group relative overflow-hidden"
                        >
                            {/* Decorative Quote Mark */}
                            <div className="absolute top-10 right-10 text-6xl font-serif text-white/[0.02] group-hover:text-blue-500/[0.05] transition-colors pointer-events-none">"</div>

                            <div className="mb-12 relative z-10">
                                <div className="flex gap-1 text-blue-500 mb-8">
                                    {[...Array(5)].map((_, i) => <FaStar key={i} className="text-[10px]" />)}
                                </div>
                                <p className="text-lg text-white/70 font-medium italic leading-relaxed group-hover:text-white/90 transition-colors">"{t.text}"</p>
                            </div>

                            <div className="flex items-center gap-5 pt-10 border-t border-white/5 relative z-10">
                                <div className="w-14 h-14 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center font-black text-xl text-blue-500 shadow-2xl group-hover:scale-110 transition-transform">
                                    {t.name[0]}
                                </div>
                                <div>
                                    <h4 className="font-black text-white mb-1 uppercase tracking-tight">{t.name}</h4>
                                    <span className="text-[10px] font-bold text-blue-500 uppercase tracking-widest">{t.role}</span>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Feedback;
